import { Injectable } from '@angular/core';
import Globalize from 'globalize';
import { LocaleService } from './locale.service';
import * as moment from 'moment';
import { isDate } from '../helpers/type-utils';

@Injectable()
export class UtilsService {

	//default number formating funcation, Globalize setting to format number depening on user location
	static FormatNumber = (value: number, IsDecimalPlace: boolean = false, maxFractionDigits: number = 0) => {

		if (value == null) {
			return null;
		}

		if (value == 0) {
			return 0;
		}

		let appLang = new LocaleService();
		let fmt = Globalize(appLang.getCurrentLocale()).numberFormatter({ maximumFractionDigits: 0 });

		if (IsDecimalPlace) {
			fmt = Globalize(appLang.getCurrentLocale()).numberFormatter({ maximumFractionDigits: maxFractionDigits });
		}

		return fmt(value);
	}

	static FormatNumberWithDecimalPlaces = (value: number, decimalDigits: number = 0) => {
		if (value == null || decimalDigits == null) {
			return null;
		}

		if (value == 0) {
			return 0;
		}

		let appLang = new LocaleService();
		let fmt = Globalize(appLang.getCurrentLocale()).numberFormatter({ maximumFractionDigits: 0 });

		return fmt(value);

	}

	static FormatNumberWithDecimalPlacesNew = (value: number, decimalDigits: number = 0) => {
	if (value == null || decimalDigits == null) {
		return null;
	}

	if (value === 0) {
		return value.toFixed(decimalDigits); // or return 0, up to your formatting preference
	}

	let appLang = new LocaleService();
	let fmt = Globalize(appLang.getCurrentLocale()).numberFormatter({
		minimumFractionDigits: decimalDigits,
		maximumFractionDigits: decimalDigits
	});

	return fmt(value);
}


	static FormatAccordingToSelectedLocale = (value: number, decimalDigits: number = 0, locale: string) => {
		if (value == null || decimalDigits == null) {
			return null;
		}

		if (value == 0) {
			return 0;
		}

		
		let fmt = Globalize(locale).numberFormatter();
		return fmt(value);

	}

	static ConvertToFormats(Datatype, Value, Format) {
		try {
			if (Value) {
				if (Datatype && Datatype == 'date' && Format && Format != "") {
					let date = new Date(Value);
					return moment(date).format(Format);
				}
				else if (Datatype && Datatype == 'date') {
					let date = new Date(Value);
					return moment(date);
				}
				else if (Datatype && Datatype == 'number' && Format && Format != "") {
					return this.FormatNumberWithDecimalPlacesWithString(Number(Value), Format)
				}
				else if (Datatype && Datatype == 'number') {
					return this.FormatNumberWithDecimalPlacesWithString(Number(Value))
				}
			}
		}
		catch (e: unknown) {
			console.log("ConvertToFormat Error-", e);
		}
		return Value;
	}

	static FormatNumberWithDecimalPlacesWithString = (value: number, format: string = "#,###.##") => {
		if (value == null || format == null) {
			return null;
		}

		if (value == 0) {
			return 0;
		}

		let appLang = new LocaleService();
		let num = Number(value);
		if (isNaN(num)) return value;
		let fmt = Globalize(appLang.getCurrentLocale()).numberFormatter();
		return (fmt(num));
	}

	static CurrcyFormat = (decimalDigits: number = 0) => {
		let format = "#,##0";
		for (let index = 1; index <= decimalDigits; index++) {
			if (index == 1) {
				format += ".#";
			}
			else {
				format += "#";
			}
		}
		return format;
	}

	static FormatNumberWithDecimalPlacesWithoutCurrecyFormat = (value: number, decimalDigits: number = 0) => {
		if (value == null || decimalDigits == null) {
			return null;
		}

		if (value == 0) {
			return 0;
		}
		
		return UtilsService.ConvertStringToNumber(value.toFixed(decimalDigits));
	}

	public static FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat = (
		value: number,
		decimalDigits: number = 0,
		DisplayMinRoundingBelowNumberFc: number = 0,
		DisplayMinRoundingPlacesFc: number = 0
	) => {
		if (value === null || decimalDigits === null) {
			return null;
		}

		if (value === 0) {
			return 0;
		}

		if (DisplayMinRoundingBelowNumberFc > value) {
			return UtilsService.ConvertStringToNumber(value.toFixed(DisplayMinRoundingPlacesFc));
		}

		
		return UtilsService.ConvertStringToNumber(value.toFixed(decimalDigits));
	}

	static FloorNumberWithDecimal = (value: number) => {
		if (value == null) {
			return null;
		}

		if (value == 0) {
			return 0;
		}
		
		return Math.floor(Number(value));
	}

	static RoundNumberWithDecimal = (value: number) => {
		if (value == null) {
			return null;
		}

		if (value == 0) {
			return 0;
		}
		
		return Math.round(Number(value));
	}

	public static ConvertStringToNumber(input: string): number {
		if (!input) return NaN;

		if (input.trim().length == 0) {
			return NaN;
		}

		return Number(input);
	}

	/*
	Ref URL for SVG https://gigacore.github.io/demos/svg-stroke-dasharray-generator/
	*/
	static getlegendMarkerPath = (item: any, uniqueid: string, SvgLinPath: any) => {

		let data = [];
		if (SvgLinPath[item.text + '-' + uniqueid]) {
			SvgLinPath[item.text + '-' + uniqueid].color = item.marker.fill;
			SvgLinPath[item.text + '-' + uniqueid].stroke = item.marker.fill;

			if (SvgLinPath[item.text + '-' + uniqueid] && SvgLinPath[item.text + '-' + uniqueid].type && SvgLinPath[item.text + '-' + uniqueid].type == 'full') {

				SvgLinPath[item.text + '-' + uniqueid].x1 = 0;//"x"
				SvgLinPath[item.text + '-' + uniqueid].y1 = 0;//"y"
				SvgLinPath[item.text + '-' + uniqueid].x2 = 15;//"width"
				SvgLinPath[item.text + '-' + uniqueid].y2 = 15;//"height"

				data.push(SvgLinPath[item.text + '-' + uniqueid]);
			}
			else {
				data.push(SvgLinPath[item.text + '-' + uniqueid]);
			}
		}
		else {
			data.push(SvgLinPath["NullValue"]);
		}
		return item.series.isVisible() ? data : null;
	}

	static getlegendMarkerPathNew = (item: any, uniqueid: string, SvgLinPath: object[]) => {
		let itemname = (item.text + '-' + uniqueid).toLowerCase();
		if (item != null && item.series != null && item.series.getValueFields() != null && item.series.getValueFields().length > 0) {
			itemname = (item.series.getValueFields()[0] + '-' + uniqueid).toLowerCase();
		}

		if (SvgLinPath && itemname) {
			let svgNewLinePath = SvgLinPath.find(t => t["name"] == itemname
				|| t["Value"] == itemname);
			if (svgNewLinePath == undefined && svgNewLinePath == null && item.text != undefined) {
				let itemnamenew = item.text + '-' + uniqueid.toLowerCase();
				let svgNewLinePath = SvgLinPath.find(t => t["name"] == itemnamenew
					|| t["Value"] == itemnamenew);
			}

			var data = [];
			if (svgNewLinePath) {
				svgNewLinePath['color'] = item.marker.fill;
				svgNewLinePath['stroke'] = item.marker.fill;
				if (svgNewLinePath && svgNewLinePath['type'] && svgNewLinePath['type'] == 'full') {
					svgNewLinePath['x1'] = 0;//"x"
					svgNewLinePath['y1'] = 0;//"y"
					svgNewLinePath['x2'] = 15;//"width"
					svgNewLinePath['y2'] = 15;//"height"
					data.push(svgNewLinePath);
				}
				else {
					

					data.push(svgNewLinePath);
				}
			}
			else {
				let temp = SvgLinPath.find(t => t["name"] == "nullvalue"
					|| t["Value"] == "nullvalue");
				data.push(temp);
			}
		}

		
		return item.series.isVisible() ? data : null;
	}

	static getlegendMarkerPathDynamic = (item: any, uniqueid: string, SvgLinPath: object[]) => {
		let data = {
			name: "nullvalue", Value: "nullvalue",
			type: '', strokeDashArray: "0,0", x1: 0, y1: 0, x2: 0, y2: 0,
			style: "", color: "", strokewidth: '', stroke: ''
		};

		if (item != null && item.series != null && item.series._options != null) {

			data.name = item.series._options.name;
			data.Value = item.series._options.valueField;
			data.type = item.series._options.type;
			data.color = item.series._options.color;
			data.stroke = item.series._options.color;

			if (item.series._options.type != null) {

				if (item.series._options.type.toLowerCase() == "line") {
					if (item.series._options.dashStyle.toLowerCase() == "dash") {
						data.strokeDashArray = "5,5";
						data.type = "dash";
						data.x1 = 1;
						data.y1 = 14;
						data.x2 = 20;
						data.y2 = 14;
						data.style = "stroke-width: 2px; stroke: " + item.series._options.color + ";";
						data.strokewidth = '2px';
					} else
						if (item.series._options.dashStyle.toLowerCase() == "dot") {
							data.strokeDashArray = "3,5";
							data.type = "dash";
							data.x1 = 1;
							data.y1 = 14;
							data.x2 = 20;
							data.y2 = 14;
							data.style = "stroke-width: 3px; stroke: " + item.series._options.color + ";";
							data.strokewidth = '3px';
						}
						else
							if (item.series._options.dashStyle.toLowerCase() == "longdash") {
								data.strokeDashArray = "1,5";
								data.type = "dash";
								data.x1 = 1;
								data.y1 = 14;
								data.x2 = 20;
								data.y2 = 14;
								data.style = "stroke-width: 2px; stroke: " + item.series._options.color + ";";
								data.strokewidth = '2px';
							}
							else if (item.series._options.dashStyle.toLowerCase() == "solid") {
								data.strokeDashArray = "0,0";
								data.type = "dash";
								data.x1 = 27;
								data.y1 = 14;
								data.x2 = 1;
								data.y2 = 14;
								data.style = "stroke-width: 2px; stroke: " + item.series._options.color + ";";
								data.strokewidth = '2px';
							}

				}
				else {
					data.strokeDashArray = "5,5";
					data.type = "full";
					data.x1 = 0;
					data.y1 = 0;
					data.x2 = 15;
					data.y2 = 15;
					data.style = "stroke-width: 2px; stroke: " + item.series._options.color + ";";
					data.strokewidth = '';
				}


			}

		}


	

	
		return item.series.isVisible() ? [data] : null;
	}

	static getURLHelper = (itemData: string) => {
		itemData = encodeURIComponent(itemData);
		itemData = itemData.replace(/\+/gi, '%2B');
		return itemData;
	}

	public static convertDateToDateId(date: Date | number | string): number {
		const dateValue: Date = new Date(date);

		if (dateValue) {
			return +(dateValue.getFullYear().toString() + ("0" + (dateValue.getMonth() + 1).toString()).slice(-2) + ("0" + dateValue.getDate().toString()).slice(-2));
		}

		return null;
	}

	public static convertDateIdToDate(dateId: number): Date {
		if (dateId) {
			const rawDate: string = dateId.toString();

			const year: number = +rawDate.substring(0, 4);
			const month: number = +rawDate.substring(4, 6);
			const day: number = +rawDate.substring(6, 8);

			return new Date(year, month - 1, day);
		}

		return null;
	}

	public static addDaysToDate(date: Date | number | string, days: number): Date {
		let result: Date = new Date(date);

		result.setDate(result.getDate() + days);

		return result;
	}

	public static dateDifferenceInDays(dateOne: Date | number | string, dateTwo: Date | number | string) {
		const _MS_PER_DAY = 1000 * 60 * 60 * 24;

		const dateOneValue: Date = isDate(dateOne) ? dateOne : new Date(dateOne);
		const dateTwoValue: Date = isDate(dateTwo) ? dateTwo : new Date(dateTwo);

		// Discard the time and time-zone information.
		let utc1 = Date.UTC(dateOneValue.getFullYear(), dateOneValue.getMonth(), dateOneValue.getDate());
		let utc2 = Date.UTC(dateTwoValue.getFullYear(), dateTwoValue.getMonth(), dateTwoValue.getDate());

		return Math.floor((utc2 - utc1) / _MS_PER_DAY);
	}

	public static dateDifferenceInSeconds(dateOne: Date | number | string, dateTwo: Date | number | string) {
		const _MS_PER_SECOND = 1000;

		const dateOneValue: Date = isDate(dateOne) ? dateOne : new Date(dateOne);
		const dateTwoValue: Date = isDate(dateTwo) ? dateTwo : new Date(dateTwo);

		return Math.floor((dateTwoValue.getTime() - dateOneValue.getTime()) / _MS_PER_SECOND);;
	}

	public static formatSecondsToTime(seconds: number) {
		const absSeconds = Math.abs(seconds);
		const hours = Math.floor(absSeconds / 3600).toString().padStart(2, '0');
		const minutes = Math.floor((absSeconds % 3600) / 60).toString().padStart(2, '0');
		const remainingSeconds = (absSeconds % 60).toString().padStart(2, '0');

		const sign = seconds < 0 ? '-' : '';
		return `${sign}${hours}:${minutes}:${remainingSeconds}`;
	}

	/**
	 *
	 * @param date
	 * @param formt
	 * @returns
	 */
	public static FormateDate(date: Date, formt: string): string {
		if (date == undefined || formt == undefined || date == null || formt == null) {
			return null;
		}
		return moment(date).format(formt);
	}

	static getURLHelperDeconding = (itemData: string) => {
		itemData = decodeURIComponent(itemData);
		return itemData;
	}

	/**
	 * The Szudzik pairing function.
	 *
	 * This function takes two non-negative integers and combines them into a single
	 * unique integer. The resulting integer can be used to store the two original
	 * integers in a single value, or to create a hash key for a two-dimensional
	 * array or map.
	 *
	 * Note that the maximum values of `a` and `b` that can be used without causing
	 * an overflow when using a 32-bit integer data type are 65535. Any values of
	 * `a` and `b` greater than this may cause an overflow and produce incorrect
	 * results. If using a larger integer data type, larger values of `a` and `b`
	 * can be used.
	 *
	 * @param a The first non-negative integer.
	 * @param b The second non-negative integer.
	 * @returns A single integer that uniquely represents the pair (a, b).
	 */
	public static szudzikPair(a: number, b: number): number {
		if (a >= b) {
			return a * a + a + b;
		} else {
			return b * b + a;
		}
	}

	/**
	 * The inverse function for the Szudzik pairing function.
	 *
	 * This function takes a single integer that was produced by the Szudzik pairing
	 * function and recovers the original pair of non-negative integers (a, b) that
	 * were used as input to the pairing function. Note that the inverse function
	 * is computationally expensive, and should be used sparingly.
	 *
	 * @param z The integer to be unpaired.
	 * @returns The original pair of non-negative integers (a, b) that were used to
	 *   produce the integer z using the Szudzik pairing function.
	 */
	public static szudzikUnpair(z: number): [number, number] {
		const sqrtZ = Math.floor(Math.sqrt(z));
		const sqZ = sqrtZ * sqrtZ;
		if (z - sqZ < sqrtZ) {
			return [z - sqZ, sqrtZ];
		} else {
			return [sqrtZ, z - sqZ - sqrtZ];
		}
	}

	/**
	 * The Cantor pairing function takes two non-negative integers as input and returns a unique non-negative integer.
	 * @param a - The first non-negative integer.
	 * @param b - The second non-negative integer.
	 * @returns A unique non-negative integer.
	 */
	public static cantorPairing(a: number, b: number): number {
		return (a + b) * (a + b + 1) / 2 + b;
	}

	/**
	 * The computeRouteHash function combines two non-negative integers (routeId and uId) into a unique non-negative integer.
	 * It uses the Cantor pairing function to ensure that the output is unique for every unique pair of input numbers.
	 * Order matters, so computeRouteHash(0, 2) and computeRouteHash(2, 0) will produce different numbers.
	 * @private
	 * @param routeId - A non-negative integer representing the routeId.
	 * @param uId - A non-negative integer representing the uId.
	 * @returns A unique non-negative integer.
	 * @throws {Error} Both routeId and uId must be non-negative integers.
	 */
	public static computeRouteHash(routeId: number, uId: number): number {
		if (typeof routeId !== 'number' || typeof uId !== 'number' || routeId < 0 || uId < 0) {
			throw new Error('Both routeId and uId must be non-negative integers.');
		}

		return UtilsService.szudzikPair(routeId, uId);
	}
}
